<template>
  <div>
      <!-- <v-row>
        <p>Dados Técnicos do serviço</p>
      </v-row> -->
      



    
  </div>
</template>



<script>
export default {
  components: {
  },

  name: "edit-accessory",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      selected: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  methods: {
    
    
  },
};
</script>
